const langInvestDateRangePicker = {
	x_months: {
		tag: 'invest.date_range_picker.x_months',
		fr: '{{count}} mois',
		en: '{{count}} months',
		plurals: {
			one: {
				fr: '{{count}} mois',
				en: '{{count}} month',
			},
			other: {
				fr: '{{count}} mois',
				en: '{{count}} months',
			},
		},
	},
	x_years: {
		tag: 'invest.date_range_picker.x_years',
		fr: 'ans',
		en: 'years',
		plurals: {
			one: {
				fr: '{{count}} an',
				en: '{{count}} year',
			},
			other: {
				fr: '{{count}} ans',
				en: '{{count}} years',
			},
		},
	},
	custom: {
		tag: 'invest.date_range_picker.custom',
		fr: 'Personnalisé',
		en: 'Custom',
	},
	all: {
		tag: 'invest.date_range_picker.all',
		fr: 'Tout',
		en: 'All',
	},
	cancel: {
		tag: 'invest.date_range_picker.cancel',
		fr: 'Annuler',
		en: 'Cancel',
	},
	submit: {
		tag: 'invest.date_range_picker.submit',
		fr: 'Valider',
		en: 'Submit',
	},
};

export default langInvestDateRangePicker;
